export function createDownload(filename: string, data: string) {
  const blob = new Blob([data], { type: 'application/json' });
  if ('msSaveBlob' in window.navigator) {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    const elem = window.document.createElement('a');
    elem.href = window.URL.createObjectURL(blob);
    elem.download = filename;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
    window.URL.revokeObjectURL(elem.href);
  }
}
